export const getConversionRate = (numA: number, numbB: number): number => {
  return Number((numA / numbB).toFixed(4));
};
